import BaseModel from "../../../core/components/input-widget/BaseModel";
import i18n from "@/shared/i18n";

export default class AllocatePaymentModel extends BaseModel {
  date = null;
  method = 'Overpayment';
  description = null;
  bank_account = null;
  invoices = []

  static TRANSLATABLE_FIELDS = [];

  rules = {
    bank_account: 'required',
  };

  attributeLabels = {
    date: i18n.t('Date'),
    method: i18n.t('Method'),
    description: i18n.t('Description'),
    bank_account: i18n.t('Bank Account'),
  };

  attributeHints = {
  }

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }
}

